/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { holidaySchemeResponseSchema } from './holidaySchemeResponseSchema';

export const pageResponseHolidaySchemeResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(holidaySchemeResponseSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
